import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Icon = ({ name: propName, ...otherProps }) => {
    const filterProps = useCallback(() => {
        let props = {};

        Object.keys(otherProps).map(key => {
            if (key.search(/^data-|^on/i) === 0) {
                props[key] = otherProps[key];
            }
        });

        return props;
    }, [otherProps]);

    return (
        <span
            className={classnames({
                'fa': true,
                [propName]: true
            })}
            {...filterProps()}
        />
    );
};

Icon.propTypes = {
    name: PropTypes.string
};

Icon.defaultProps = {
    name: ''
};

export default Icon;
